module.exports = __webpack_public_path__ + "media/images/thumbs/anatomyphysiology/av59-9447dae39920014cf239c652927d1ad8.jpg";